import {useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {HotlineNumber} from "../typedefs";
import {useQuery} from "react-query";
import useDebouncer from "../../../hooks/debouncer";

export async function fetchHotlineNumbers(page: number, limit: number, search: string, id: string) {

    const res = await platformAPI.get<PaginatedResponseV2<HotlineNumber>>(`api/hotlines/${id}/numbers`, {
        params: {
            page,
            limit,
            search,
        }
    })

    return res.data

}


export function useGetHotlineNumbers(id: string|null, initialSearch = "", initialPage = 1) {
    const [page, setPage] = useState(initialPage);
    const [limit, setLimit] = useState(20);
    const [search, setSearch] = useState(initialSearch);

    const debouncedSearch = useDebouncer(search, 300);


    const {data, isLoading, error, refetch} = useQuery(
        ["hotline-numbers", id, page, limit, debouncedSearch],
        () => fetchHotlineNumbers(page, limit, debouncedSearch, id!),
        {
            enabled: !!id,
            cacheTime: 0,
            refetchOnMount: true,
        }
    );

    return {
        page, setPage,
        limit, setLimit,
        search, setSearch,
        data,
        isLoading,
        error,
        refetch
    }


}